<template>
    <ul class="space-y-20px">
        <li v-for="(item, index) in items" :key="index" class="flex items-start text-16 md:text-18 lg:text-20 xl:text-22">
                <svg class="mr-4 w-8 md:w-12 shrink-0 pt-1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 40 20" viewBox="0 0 40 20"><path d="M28.6 12H.2V7.5h28.4V.6l11.2 9.1-11.2 9.8V12z" style="fill:#e67300"/></svg>
            {{ item }}
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    setup() {
        
    },
}
</script>